<div class="export">
  <img src="./assets/img/icons/download.svg" alt="">
  <p class="export-title">{{ 'Export' | uppercase }}</p>
</div>
